<template>
  <div class="booking">
    <div class="container-fluid">
      <div class="row __bookingwrapper" v-if="isLoading || bookmarkIsLoading">
          <div class="col-md-12 text-center">
            <half-circle-spinner
              :animation-duration="750"
              :size="100"
              color="#1D3354"
              class="mx-auto"
            />
          </div>
      </div>
      <div class="col-md _noavailable text-center" v-if="!isLoading  && !bookmarkIsLoading && booking && booking.length < 1">
        <p>Sorry we currently do not have any match for your instant price request in this route/freight mode.
          However, you can still find the best price for your  shipment in this route by making request for quotation (RFQ) by clicking the button below:
        </p>
        <router-link to="request-shipment">
          <button type="button" name="button" class="_global__button--corporite mt-4">Make RFQ</button>
        </router-link>
      </div>
      <div class="col-md __bookingwrapper" v-if="!isLoading && !bookmarkIsLoading && booking && booking.length > 0">
        <div class="row p-0 justify-content-between __top">
          <p> {{ inputData.form.originArea }} to {{ inputData.form.destinationArea }} |  Showing {{ booking.length }} products</p>
          <div class="row __customdropdownBook">
            <span class="__textspan">Short by :</span>
            <b-input-group>
              <b-dropdown right text="">
                <b-dropdown-item><span>Best deal</span></b-dropdown-item>
                <b-dropdown-item><span>Cheapest</span></b-dropdown-item>
                <b-dropdown-item><span>Fastest</span></b-dropdown-item>
                <b-dropdown-item><span>Ratings</span></b-dropdown-item>
              </b-dropdown>
              <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
            </b-input-group>
          </div>
        </div>
        <div class="row p-0 justify-content-center __masterblock">
          <div class="__filterblock">
            <div class="row m-0 align-items-center justify-content-between __header">
              <h5>Filter</h5>
              <p>Reset Filter</p>
            </div>
            <div class="row m-0 __contentblock">
              <h6 class="col-md-12 p-0">Price Range</h6>
              <b-form-input class="__price1" type="number" placeholder="0" />
              <hr>
              <b-input-group class="__price1" prepend="IDR">
                <b-form-input class="__border __price2" />
              </b-input-group>
            </div>
            <hr>
            <div class="row m-0 __contentblock2">
              <h6 class="col-md-12 p-0">Provider Names</h6>
              <div class = "__options_">
                <div class="custom-control custom-checkbox">
                  <label class="custom-control-label __labelform" for="check1">All</label>
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="check1"
                    name=""
                  >
                </div>
              </div>
            </div>
            <hr>
            <div class="row m-0 __contentblock3">
              <h6 class="col-md-12 p-0">Shipping Lines</h6>
              <div class="__options_">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="check1" name="">
                  <label class="custom-control-label __labelform" for="check1">All</label>
                </div>
              </div>
            </div>
            <div class="_gotobokkmark">
              <router-link to="/bookmark">Go to Bookmark</router-link>
            </div>
          </div>
          <div class="__listPriceblock">
            <div class="row __listbox"
                v-for="(item, i) in bookingTemp" :key="`${item.quoteId}+${i}`">
              <div class="col-md-2 __box1 d-flex justify-content-center align-items-center">
                <p><b>{{ inputData.form.originArea }} to {{ inputData.form.destinationArea }}</b></p>
              </div>
              <div class="col-md-10 p-3 d-flex align-items-center justif-content-center">
                <div class="row m-0 w-100 h-100">
                  <div class="col-md-3 p-0 d-flex align-items-center __hrVertical">
                    <div>
                      <p class="__heading">{{ item.orderShippingLine}}</p>
                      <img  src = "@/assets/image/instantprice/Group 2576.png">
                    </div>
                  </div>
                  <div class="col-md-3 pr-0 d-flex align-items-center __hrVertical">
                    <div class="w-100">
                      <div class="row m-0">
                        <p class="col-md-6 p-0">Valid Until</p>
                        <p class="col-md p-0">: {{ item.orderValidUntil }}</p>
                      </div>
                      <div class="row m-0">
                        <p class="col-md-6 p-0">Transit Time</p>
                        <p class="col-md p-0">: {{ item.orderTransittimeMin }} - {{ item.orderTransittimeMax }} Days</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex flex-column align-items-center justify-content-center __hrVertical">
                    <h5 class="__price">{{ item.orderPriceTotal | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}</h5>
                    <a class="__showPrice" href="#" @click.prevent="priceDetails(item.quoteId, item.vendorName, item.orderPriceTotal)">Show price detail</a>
                  </div>
                  <div class="col-md-2 d-flex align-items-center justify-content-center">
                    <img  v-if="item.bookmarked" class="__bookmarkedImg __pointer" disabled src="@/assets/image/icon/sb-bookmarked.svg" alt="">
                    <img  v-else class="__bookmarkImg __pointer" @click="addBookmark(item, item.quoteId)" src="@/assets/image/icon/sb-bookmark.svg" alt="">
                    <!-- <router-link to="/ip-booking-form"> -->
                    <router-link :to="{ name: 'BookingForm', params: {type: 'instant-price', id: item.quoteId.split('_').join('-')}}">
                      <button class="col-xs-3 text-center __buttonBook __pointer" type="button" name="button"
                        @click="dataToForm(item)"
                      >Book</button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import _ from 'lodash'
import mixin from '@/mixin'

export default {
  name: 'Booking',
  props: {
    inputData: Object
  },
  components: {
    HalfCircleSpinner
  },
  mixins: [mixin],
  data () {
    return {
      orderPrice: {
        vendorName: '',
        orderPriceTotal: 0,
        orderPriceFreight: [],
        orderPriceOrigin: [],
        orderPriceDestination: []
      },
      bookingTemp: [],
      marked: false,
      baseUrl: this.mixGetBlobUrl(),
      payloadLog: {
        featureName: 'CREATE INSTANT PRICE',
        featureStep: 6,
        stepName: 'Result Instant Price',
        featureProcess: {
          status: 'success',
          data: {}
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      booking: 'instantprice/items',
      isLoading: 'instantprice/isLoading',
      bookmark: 'bookmark/bookmark',
      postBookmark: 'bookmark/postBookmark',
      bookmarkIsLoading: 'bookmark/isLoading'
    })
  },
  methods: {
    priceDetails (quoteId, vendorName, orderPriceTotal) {
      this.orderPrice.vendorName = vendorName
      this.orderPrice.orderPriceTotal = orderPriceTotal
      let prices = this.booking.filter(item => (item.quoteId === quoteId))[0]
      this.orderPrice.orderNote = prices.orderNote
      let orderPriceFreight = prices.orderPriceFreight
      let orderPriceOrigin = prices.orderPriceOrigin
      let orderPriceDestination = prices.orderPriceDestination
      this.orderPrice.orderPriceFreight = _.reduce(orderPriceFreight, (combinedPricelistPerComponentPrice, pricelistPerComponentPrice) => {
        return combinedPricelistPerComponentPrice.concat(pricelistPerComponentPrice)
      }, [])
      this.orderPrice.orderPriceOrigin = _.reduce(orderPriceOrigin, (combinedPricelistPerComponentPrice, pricelistPerComponentPrice) => {
        return combinedPricelistPerComponentPrice.concat(pricelistPerComponentPrice)
      }, [])
      this.orderPrice.orderPriceDestination = _.reduce(orderPriceDestination, (combinedPricelistPerComponentPrice, pricelistPerComponentPrice) => {
        return combinedPricelistPerComponentPrice.concat(pricelistPerComponentPrice)
      }, [])
      const orderPrice = this.orderPrice
      this.$eventHub.$emit('dialog-pricedetails', orderPrice)
    },
    dataToForm (data) {
      const book = {
        inputData: this.inputData,
        bookData: data
      }
      this.$store.dispatch('instantprice/SET_INSTANTPRICE', book)
    },
    fetchAllBookmark () {
      this.$store.dispatch('bookmark/FETCH_BOOKMARK')
    },
    addBookmark (item, id) {
      const payload = {
        query: this.inputData,
        quote: item
      }
      this.bookingTemp.forEach(book => {
        if (book.quoteId === id) {
          book.bookmarked = true
        }
      })
      this.$store.dispatch('bookmark/POST_BOOKMARK', payload)
    },
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.booking
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    setLocalStorage () {
      // set input data instant price to local storage
      const data = JSON.stringify(this.inputData)
      localStorage.setItem('instantPriceData', data)
    }
  },
  mounted () {
    this.fetchAllBookmark()
    this.init()
    this.setLocalStorage()
  },
  watch: {
    booking (data) {
      if (data) {
        this.bookingTemp = data
        this.bookingTemp.map((item) => {
          Object.assign(item, { bookmarked: item.book })
        })
      }
    },
    postBookmark (data) {
      if (data) {
        this.fetchAllBookmark()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/Booking.vue